import { render, staticRenderFns } from "./MessageOperations.vue?vue&type=template&id=42bfd781&"
import script from "./MessageOperations.vue?vue&type=script&lang=js&"
export * from "./MessageOperations.vue?vue&type=script&lang=js&"
import style0 from "./MessageOperations.vue?vue&type=style&index=0&id=42bfd781&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
